import { medaiHost, UN_AUTHORIZED, ABORT_ERROR } from 'Helpers/apiurl';
import cryptLib from 'cryptlib';
import { toast as toastr } from 'react-toastify';

import { store } from 'Store/index';
import { convertUTCTOLocalTimeStamp } from 'Components/Common/TimeStamp';
import dateFormat from 'dateformat';

/** Buffer Source for encryption */
const SECRET_BUFFER_SOURCE = 'ddc0f15cc2c90fca';

/** SECRET Key for encryption */
const ENCRYPTION_SECRET_KEY = 'Q2T6U8O0P9I8Y5R4W1';

const checkUrlHttp = new RegExp('^(http|https)://', 'i');

export const PAGELIMIT = 10;
export const PAGESTOSHOW = 5;
export const INITIALPAGE = 1;

export const paginationLimitArray = [ 5, 10, 20, 50, 100 ];

export const handleApiError = (error) => {
    if(error.toString() !== UN_AUTHORIZED && error.toString() !== ABORT_ERROR) {
        toastr.dismiss();
        return toastr.error(error.toString());
    }
}

export const clearStorage = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('userdetail');
}

export function AESencrypt(data, key) {
    try {
        const keyVal = cryptLib.getHashSha256(key, 32);
        const encryptedText = cryptLib.encrypt(data, keyVal, 'ddc0f15cc2c90fca');
        return encryptedText;
    } catch (exception) {
        throw exception;
    }
};

export function AESdecrypt(data, key) {
    try {
        const keyVal = cryptLib.getHashSha256(key, 32);
        const originalText = cryptLib.decrypt(data, keyVal, 'ddc0f15cc2c90fca');
        return originalText;
    } catch (exception) {
        throw exception;
    }
};

/**
 * convert array of object to csv format for export
 * @param {array} objArray 
 */
export const ConvertToCSV = (objArray) => {
    const array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';

    for (let i = 0; i < array.length; i++) {
        let line = '';
        for (const index in array[ i ]) {
            if (line != '') line += ','

            line += array[ i ][ index ];
        }

        str += line + '\r\n';
    }

    return str;
}

/**
   * getFormattedText() handles text and formats into proper special characters
   * @param {string} text 
   */
export const getFormattedText = (text) => {
    if(!text) return '';
    return text.replace(/&nbsp;/g, '')
    .replace(/&amp;/g, '&')
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
}

export const removeSmiley = (text) => {
    return text.replace( /[^a-zA-Z0-9`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ]/gm, '');
}

/** 
 * A Helper function that encrypts the data passed and set to localStorage for the key
 * @param {string} key - key to be stored in localStorage
 * @param {string} data - data to be stored for that key
*/
export const encryptAndSaveToLocalStorage = (key, data) => {
	const encryptedDetails = AESencrypt(data, ENCRYPTION_SECRET_KEY);
	localStorage.setItem(key, encryptedDetails);
	return true;
};

/** 
 * A Helper function that decrypt the data of the passed Key from localStorage
 * @param {string} key - key to be retreved from localStorage
*/
export const decryptDataFromLocalStorage = (key) => {
	return AESdecrypt(localStorage.getItem(key), ENCRYPTION_SECRET_KEY)
}

/** 
 * A helper function that decrypts the user token from localStorage
 * @returns {string} token
 */
export const decryptUserToken = () => {
	try {
		const encToken = localStorage.getItem('user');
		return encToken ? AESdecrypt(encToken, ENCRYPTION_SECRET_KEY) : encToken;
	} catch (ex) {
		return undefined;
	}
};

/** 
 * A helper function that return the authorization header with token
 * @returns {Object} { Authorization: token }
 */
export const authHeader = () => ({ Authorization: decryptUserToken() });

export default function fileTokenToBase64(image) {
    return checkUrlHttp.test(image) ? image : 
    `${ medaiHost }/${ image }?mf=${ decryptUserToken() }`
}

export const checkModuleActionPermission = (module, action) => {
	const state = store.getState();
	const permission = JSON.parse(state.profile.permission || '{}');
	if (permission[ module ]?.[ action ] === true) {
		return true;
	} else {
		toastr.error(`You don't have access to ${ action } this module`);
		return false;
	}
};

export const getTimezoneName = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export const formatSortForUrl = (sort) => {
    if(sort.sortBy && sort.orderBy){
        return [
            { id: 'sortBy', value: sort.sortBy },
            { id: 'orderBy', value: sort.orderBy }
        ]
    } 
    return [];
}

export const isNumber = (value) => {
    const rgx = /^[0-9]*$/;
    return value.match(rgx);
}
export const dateAndTimeFormat = (content) => {
    const val = content && content.replace('T',' ');
    const time = content && convertUTCTOLocalTimeStamp(val);
    return dateFormat(time, 'mmm d, yyyy / hh:MM:ss TT ')
}

// detect emojis
export const containsEmoji = (str) => {
  return /[\u{1F600}-\u{1F6FF}|\u{1F300}-\u{1F5FF}|\u{1F700}-\u{1F77F}|\u{1F780}-\u{1F7FF}|\u{1F900}-\u{1F9FF}|\u{1FA00}-\u{1FA6F}|\u{1FA70}-\u{1FAFF}|\u2600-\u26FF\u2700-\u27BF]/gu.test(str);
};
